import { types as t, Instance, SnapshotOut } from 'mobx-state-tree';
import WidgetModel from '~/mst/models/widget';
import NodesStore from '~/mst/models/nodes';
import type { HistogramLevel } from '~/utils/histogram';

// The parameter in the shape of a custom air quality report's parameter row: its data point on
// each device, its unit and its alert levels
export type DistributionParameter = {
  key: string | null;
  unit: string | null;
  data_point_ids: string[];
  levels: Array<HistogramLevel & { name?: string }>;
};

const DistributionWidgetModel = t
  .compose(
    WidgetModel,
    t.model({
      type: 'DistributionWidget',
      name: t.maybeNull(t.string),
      node_id: t.array(t.string),
      parameter: t.maybeNull(t.frozen<DistributionParameter>()),
      // Aggregation interval in minutes, as in reports
      aggregate: t.maybeNull(t.number),
      nodes: t.maybeNull(NodesStore)
    })
  )
  // Period of the last fetch, for the data coverage
  .volatile(() => ({
    period: null as { from: number; to: number } | null
  }))
  .named('DistributionWidget');

export interface IDistributionWidgetModel extends Instance<typeof DistributionWidgetModel> {}
export interface IDistributionWidgetModelSnapshotOut extends SnapshotOut<typeof DistributionWidgetModel> {}

export default DistributionWidgetModel;
